import { makeAutoObservable, runInAction } from "mobx";
import { toast } from "react-toastify";
import agent from "../api/agent";
import { Carga, Information } from "../models/Carga";
import {  Profile } from "../models/profile";
import { store } from "./store";

export default class CargaInscripcionStore {
    carga: Carga | null = null;
    nformation: Information | null = null;
    profile: Profile | null = null;
    loadingProfile = false;
    uploading = false;
    loading= false;
    selectedFile='';
    mensajes=''; 
    ocultar='' 
    
    Respuesta = new Map<any, Information>();

    constructor() {
        makeAutoObservable(this);
    }

    get isCurrentUser() {
        if (store.userStore.user && this.profile) {
            return store.userStore.user.userName === this.profile.userName;
        }
        return false;
    }

    get Information() {
        return Array.from(this.Respuesta.values());
       
    }

    loadProfile = async (username: string) => {
        this.loadingProfile = true;
        try {
            const profile = await agent.Profiles.get(username);
            runInAction(() => {
                this.profile = profile;
                this.loadingProfile = false;
            })
        } catch (error) {
            runInAction(() => this.loadingProfile = false);
        }
    }

    uploadFile = async (selectedFile: File) => {
        try {
            await agent.Cargas.uploadFileInscripcion(selectedFile).then( response => {
                this.mensajes = '';
                for(let a = 0;a<response.data.length;a++){
                    let respuesta = (response.data[a]["information"])
                    this.mensajes +='<li style="font: Gotham, font-size: 16px, paddin-right: 20px">'+response.data[a]["information"]+'.</li>';
                    this.ocultar +='<p style="font: Gotham, font-size: 16px, paddin-right: 20px">'+'Exito</p>';
                }                             
            })          
        } catch (error) {
            this.mensajes ='<p>Debe subir un Archivo en Formato Excel</p>';
        }
    }    
}

    
    

